"use strict";

window.App = window.App || {};

/**
 * Shared abort / stale-id / loader / chrome helpers for contact + company profile drawers.
 */
window.App.profileDrawer = {
	ensureStore: function (storeKey) {
		window.App = window.App || {};
		if (!window.App[storeKey]) {
			window.App[storeKey] = { request: null };
		}
		return window.App[storeKey];
	},

	abortRequest: function (storeKey) {
		const store = this.ensureStore(storeKey);
		if (store.request && typeof store.request.abort === "function") {
			store.request.abort();
		}
		store.request = null;
	},

	setLoading: function (loadingSelector, contentsSelector, isLoading) {
		const $loading = jQuery(loadingSelector);
		const $contents = jQuery(contentsSelector);
		const $cardBody = $loading.closest(".profile-drawer-body");

		if (isLoading) {
			$contents.empty();
			$loading.removeClass("d-none");
			$cardBody.addClass("is-profile-loading");
		} else {
			$loading.addClass("d-none");
			$cardBody.removeClass("is-profile-loading");
		}
	},

	resetContactChrome: function () {
		jQuery("#contact_follow_up_days").empty();
		jQuery("#contact_last_activity").empty();
		jQuery("#contact_created").empty();
		jQuery("#contactDrawerDuplicatesButton").hide();
	},

	_findDrawerSummarySection: function (label) {
		return jQuery("#contact_profile_contents .drawerpadding").filter(function () {
			return jQuery(this).find("h5.contact-primary").first().text().trim() === label;
		}).first();
	},

	_setDrawerSummaryField: function (label, content, isHtml) {
		const $section = this._findDrawerSummarySection(label);
		if (!$section.length) {
			return;
		}

		$section.find(".fs-6.text-gray-500").remove();
		const $value = jQuery('<div class="fs-6 text-gray-500"></div>');
		if (isHtml) {
			$value.html(content);
		} else {
			$value.text(content);
		}
		$section.find("h5.contact-primary").first().after($value);
	},

	_escapeHtml: function (value) {
		return jQuery("<div>").text(value || "").html();
	},

	_buildAddressSummaryHtml: function ($form) {
		const street = jQuery.trim($form.find('[name="street"]').val() || "");
		const city = jQuery.trim($form.find('[name="city"]').val() || "");
		const state = jQuery.trim($form.find('[name="state"]').val() || "");
		const zip = jQuery.trim($form.find('[name="zip"]').val() || "");

		if (!street && !city && !state && !zip) {
			return "---";
		}

		let html = "";
		if (street) {
			html += this._escapeHtml(street) + "<br />";
		}

		if (city && state && zip) {
			html += this._escapeHtml(city + ", " + state + " " + zip);
		} else if (city && state) {
			html += this._escapeHtml(city + ", " + state);
		} else if (city && zip) {
			html += this._escapeHtml(city + " " + zip);
		} else if (state && zip) {
			html += this._escapeHtml(state + " " + zip);
		} else {
			html += this._escapeHtml(city || state || zip);
		}

		return html;
	},

	_collectFormValues: function ($form, baseName, count) {
		const values = [];
		for (let i = 1; i <= count; i++) {
			const fieldName = i === 1 ? baseName : baseName + "_" + i;
			const value = jQuery.trim($form.find('[name="' + fieldName + '"]').val() || "");
			if (value) {
				values.push(value);
			}
		}
		return values;
	},

	updateContactSummaryFromSettings: function (response) {
		const $form = jQuery("#kt_account_profile_details_form");
		if (!$form.length) {
			return;
		}

		const firstName = jQuery.trim($form.find('[name="first_name"]').val() || response?.first_name || "");
		const lastName = jQuery.trim($form.find('[name="last_name"]').val() || response?.last_name || "");
		const title = jQuery.trim($form.find('[name="title"]').val() || response?.title || "");
		const fullName = jQuery.trim(firstName + " " + lastName) || "---";
		const titleDisplay = title || "---";
		const initials = ((firstName.charAt(0) || "") + (lastName.charAt(0) || "")).toUpperCase();
		const email = jQuery.trim($form.find('[name="email"]').val() || "");
		const phone = jQuery.trim($form.find('[name="phone"]').val() || "");
		const companyId = response?.company_id ?? null;
		const companyName = response?.company_name || "";

		jQuery("#divCurrentContactName").text(fullName);
		jQuery(".contactdrawername .fs-6.text-gray-500").first().text(titleDisplay);
		jQuery(".contactdrawername .symbol-label").text(initials);
		jQuery(".contactdrawername .avatar-wrapper > span").first().text(initials);

		const $card = jQuery(".contactdrawername .contact_profile_avatar");
		if ($card.length) {
			$card.find(".user-card-name > span").first().text(fullName);
			$card.find(".user-card-title").text(title);
			$card.find(".fw-boldest").filter(function () {
				return jQuery(this).text().trim() === "Email:";
			}).next(".text-primary").text(email);
			$card.find(".fw-boldest").filter(function () {
				return jQuery(this).text().trim() === "Phone:";
			}).next(".text-primary").text(phone);
			$card.find(".fw-boldest").filter(function () {
				return jQuery(this).text().trim() === "Company:";
			}).next(".text-primary").text(companyName || "");
		}

		this._setDrawerSummaryField("Title", titleDisplay);
		this._setDrawerSummaryField("Address", this._buildAddressSummaryHtml($form), true);

		const $interest = $form.find("#interest_level_id");
		const interestText = $interest.val() ? jQuery.trim($interest.find("option:selected").text() || "") : "";
		this._setDrawerSummaryField("Interest Level", interestText || "---");

		let companyHtml = "---";
		if (companyId && companyName) {
			companyHtml = "<a href='#' onClick='window.viewCompany(event, " + companyId + ")'>" + this._escapeHtml(companyName) + "</a>";
		}
		this._setDrawerSummaryField("Company", companyHtml, true);

		const phones = this._collectFormValues($form, "phone", 10);
		this._setDrawerSummaryField("Phone Number(s)", phones.length ? phones.map(this._escapeHtml.bind(this)).join("<br />") : "---", !!phones.length);

		const emails = this._collectFormValues($form, "email", 10);
		this._setDrawerSummaryField("Email Address", emails.length ? emails.map(this._escapeHtml.bind(this)).join("<br />") : "---", !!emails.length);
	},

	updateContactsTableRowFromSettings: function (response) {
		const table = window.contactsDataTable;
		const patch = response?.datatable_row;
		if (!table || !patch?.id) {
			return false;
		}

		if (patch.company_id && response.company_name) {
			window.companiesById = window.companiesById || {};
			window.companiesById[patch.company_id] = response.company_name;
		}

		let updated = false;
		table.rows().every(function () {
			const current = this.data();
			if (!current || String(current.id) !== String(patch.id)) {
				return;
			}

			this.data(Object.assign({}, current, patch)).invalidate("data");
			updated = true;
		});

		if (updated) {
			window.KTMenu?.createInstances?.();
		}

		return updated;
	},

	refreshContactDrawerActivity: function (contactId) {
		if (!contactId || !jQuery("#contact_activity_timeline").length || typeof moment !== "function") {
			return;
		}

		if (typeof window.getActivityForContact !== "function") {
			return;
		}

		const $root = jQuery("#kt_drawer_view_contact");
		const $picker = $root.find(".js-daterange").first();
		if (!$picker.length) {
			return;
		}

		const drp = $picker.data("daterangepicker");
		const args = Object.assign(
			{ target: "#contact_activity_timeline", contactId: contactId },
			$picker.data("callback-args") || {}
		);
		args.contactId = contactId;

		const start = drp ? drp.startDate.clone() : moment().subtract(29, "days");
		const end = drp ? drp.endDate.clone() : moment();
		const label = jQuery.trim($picker.find(".js-daterange-title").text()) || "Last 30 Days";

		window.getActivityForContact({ start: start, end: end, label: label, args: args, root: $root[0] });
	},

	_ensureHttpPrefix: function (url) {
		const trimmed = jQuery.trim(url || "");
		if (!trimmed) {
			return "";
		}
		if (/^https?:\/\//i.test(trimmed)) {
			return trimmed;
		}

		return "http://" + trimmed;
	},

	updateCompanyLastActivity: function (lastActivity) {
		if (lastActivity) {
			jQuery("#company_last_activity").html(lastActivity);
		}
	},

	refreshCompanyDrawerActivity: function (companyId) {
		if (!companyId || !jQuery("#activity_timeline").length || typeof moment !== "function") {
			return;
		}

		const start = moment().subtract(30, "days").format("YYYY-MM-DD");
		const end = moment().format("YYYY-MM-DD");

		jQuery.ajax({
			type: "GET",
			url: "/companies/id/" + companyId + "/activity/get/start/" + start + "/end/" + end,
			success: function (data) {
				jQuery("#activity_timeline").html(data);
			},
		});
	},

	refreshCompanyDrawerAfterSave: function (response) {
		const companyId = response?.id || window.currentCompanyID;

		this.updateCompanyLastActivity(response?.last_activity);
		this.refreshCompanyDrawerActivity(companyId);
	},

	updateCompanySummaryFromOverview: function (response) {
		const $form = jQuery("#form_settings");
		if (!$form.length) {
			return;
		}

		const name = jQuery.trim($form.find('[name="name"]').val() || response?.name || "");
		const isAlias = response?.is_alias ? " (alias)" : "";
		const phone = jQuery.trim($form.find('[name="phone"]').val() || response?.phone || "");
		const website = jQuery.trim($form.find('[name="website"]').val() || response?.website || "");
		const street = jQuery.trim($form.find('[name="address"]').val() || response?.street_address || "");
		const city = jQuery.trim($form.find('[name="city"]').val() || response?.city || "");
		const state = jQuery.trim($form.find('[name="state"]').val() || response?.state || "");
		const zip = jQuery.trim($form.find('[name="zip"]').val() || response?.zip || "");
		const externalCompanyId = jQuery.trim($form.find('[name="company_id"]').val() || response?.external_company_id || "");
		const companyRecordId = response?.id || window.currentCompanyID;
		const logoUrl = response?.logo_url || "";

		jQuery("#divCurrentCompanyName").text(name + isAlias);

		if (logoUrl) {
			const $logoWrap = jQuery("#company_profile_logo");
			jQuery("#company_profile_initials").remove();
			let $logo = jQuery("#company_logo_img");
			if (!$logo.length) {
				$logo = jQuery('<img alt="">').attr("id", "company_logo_img");
				$logoWrap.append($logo);
			}
			$logo.attr("src", logoUrl).attr("alt", name);
		}

		const $website = jQuery("#company_profile_website");
		if (website) {
			const websiteHref = this._ensureHttpPrefix(website);
			$website.html('<a href="' + this._escapeHtml(websiteHref) + '" target="_blank" rel="noopener">' + this._escapeHtml(website) + "</a>");
		} else {
			$website.html('<span class="company-profile-empty">---</span>');
		}

		const addressParts = [];
		if (street) {
			addressParts.push("<div>" + this._escapeHtml(street) + "</div>");
		}
		const cityLine = [city ? city + "," : "", state, zip].filter(Boolean).join(" ").trim();
		if (cityLine) {
			addressParts.push("<div>" + this._escapeHtml(cityLine) + "</div>");
		}
		jQuery("#company_profile_address").html(addressParts.length ? addressParts.join("") : '<span class="company-profile-empty">---</span>');

		const $phones = jQuery("#company_profile_phones");
		let $primaryPhone = $phones.find('[data-company-phone="primary"]');
		if (phone && companyRecordId) {
			$phones.find(".company-profile-empty").remove();
			if (!$primaryPhone.length) {
				$primaryPhone = jQuery('<a href="#" data-company-phone="primary"></a>');
				$phones.prepend($primaryPhone);
			}
			const safePhone = phone.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
			$primaryPhone
				.attr("onclick", 'window.companyPhoneNumberClick(event, "' + companyRecordId + '", "' + safePhone + '"); return false;')
				.text(phone);
		} else if ($primaryPhone.length) {
			$primaryPhone.remove();
			if (!$phones.children().length) {
				$phones.html('<span class="company-profile-empty">---</span>');
			}
		}

		const $emails = jQuery("#company_profile_emails");
		const email = jQuery.trim($form.find('[name="email"]').val() || response?.email || "");
		let $primaryEmail = $emails.find('[data-company-email="primary"]');
		if (email) {
			$emails.find(".company-profile-empty").remove();
			if (!$primaryEmail.length) {
				$primaryEmail = jQuery('<a data-company-email="primary"></a>');
				$emails.prepend($primaryEmail);
			}
			$primaryEmail.attr("href", "mailto:" + email).text(email);
		} else if ($primaryEmail.length) {
			$primaryEmail.remove();
			if (!$emails.children().length) {
				$emails.html('<span class="company-profile-empty">---</span>');
			}
		}

		jQuery("#company_profile_external_id").text(externalCompanyId || "---");

		this.updateCompanyLastActivity(response?.last_activity);
	},

	resetCompanyChrome: function () {
		jQuery("#company_last_activity").empty();
		jQuery("#company_created").empty();
	},

	/**
	 * @param {object} options
	 * @param {string} options.storeKey
	 * @param {string|number} options.id
	 * @param {string} options.url
	 * @param {string} options.contentsSelector
	 * @param {string} options.loadingSelector
	 * @param {function} options.getCurrentId
	 * @param {function} options.setCurrentId
	 * @param {function} options.resetChrome
	 * @param {function} [options.beforeFetch]
	 * @param {function} [options.onSuccess]
	 * @param {object} options.drawer - KTDrawer instance
	 */
	load: function (options) {
		const self = this;
		const store = this.ensureStore(options.storeKey);
		const requestedId = options.id;

		this.abortRequest(options.storeKey);

		if (typeof options.beforeFetch === "function") {
			options.beforeFetch();
		}

		options.setCurrentId(requestedId);
		options.resetChrome();
		this.setLoading(options.loadingSelector, options.contentsSelector, true);

		const xhr = jQuery.ajax({
			type: "GET",
			url: options.url,
			success: function (data) {
				if (Number(requestedId) !== Number(options.getCurrentId())) {
					return;
				}

				self.setLoading(options.loadingSelector, options.contentsSelector, false);
				jQuery(options.contentsSelector).html(data);

				if (typeof options.onSuccess === "function") {
					options.onSuccess(data);
				}
			},
			error: function (_xhr, textStatus) {
				if (textStatus === "abort") {
					return;
				}

				if (Number(requestedId) !== Number(options.getCurrentId())) {
					return;
				}

				self.setLoading(options.loadingSelector, options.contentsSelector, false);

				if (options.drawer && typeof options.drawer.hide === "function") {
					options.drawer.hide();
				}

				if (typeof window.toastError === "function") {
					window.toastError("Unable to load this profile.");
				}
			},
			complete: function () {
				if (store.request === xhr) {
					store.request = null;
				}
			},
		});

		store.request = xhr;

		if (options.drawer && typeof options.drawer.show === "function") {
			options.drawer.show();
		}
	},

	resetOnHidden: function (options) {
		this.abortRequest(options.storeKey);
		this.setLoading(options.loadingSelector, options.contentsSelector, false);
		jQuery(options.contentsSelector).empty();
		options.resetChrome();

		if (typeof options.onHidden === "function") {
			options.onHidden();
		}
	},
};
